export const CONSULTATION_ENCOUNTER = {
  uuid: 'c0c5e001-c0c5-4c0c-8c0c-c0c5c0c5e001',
  display: 'Consultation Details',
} as const;

export const CONSULTATION_CONCEPTS = {
  CONTEXT: 'c0c50000-c0c5-4c0c-8c0c-c0c5c0c50000',
  MODE: 'c0c50001-c0c5-4c0c-8c0c-c0c5c0c50001',
  INFORMATION_PROVIDED_BY: 'c0c50002-c0c5-4c0c-8c0c-c0c5c0c50002',
  RELIABILITY: 'c0c50003-c0c5-4c0c-8c0c-c0c5c0c50003',
  REMARK: 'c0c50004-c0c5-4c0c-8c0c-c0c5c0c50004',
  INFORMANT: 'c0c50005-c0c5-4c0c-8c0c-c0c5c0c50005',
} as const;

export const CONSULTATION_CONTEXT_CONCEPT_REP =
  'custom:(uuid,display,setMembers:(uuid,display,datatype:(display),answers:(uuid,display)))';

/** Stable answer concept UUIDs used for conditional form logic. */
export const CONSULTATION_ANSWER_CONCEPTS = {
  PATIENT_NOT_PRESENT: 'c0c5a103-c0c5-4c0c-8c0c-c0c5c0c5a103',
  INFORMATION_FROM_PATIENT: 'c0c5a201-c0c5-4c0c-8c0c-c0c5c0c5a201',
  INFORMATION_FROM_INFORMANT: 'c0c5a202-c0c5-4c0c-8c0c-c0c5c0c5a202',
  INFORMATION_FROM_BOTH: 'c0c5a203-c0c5-4c0c-8c0c-c0c5c0c5a203',
} as const;
